import { render } from "./MudasFormView.vue?vue&type=template&id=ad02a9a8"
import script from "./MudasFormView.vue?vue&type=script&lang=js"
export * from "./MudasFormView.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/salvando-arvores-front/salvando-arvores-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__